import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {}

const folderSettingsModule = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

export default folderSettingsModule